/* eslint-disable @typescript-eslint/no-unused-vars */
/* for mobx decorators? */
import { getter } from '@progress/kendo-react-common';
import { Field, Form, FormElement } from '@progress/kendo-react-form';
import { Input } from '@progress/kendo-react-inputs';
import { Error } from '@progress/kendo-react-labels';
import { inject, observer } from 'mobx-react';
import React from 'react';

import { IField } from '../../../../interfaces/ITwilioMessage';
import ChatStore from '../../../../stores/ChatStore';
import CollectionFormStyle from './CollectionFormStyles';

export const INVALID_PHONE_FORMAT = 'Phone number format is invalid.';
export const REQUIRED_FIELD = 'This field is required.';
export const SPLITTER = ' | ';

export function generateAnswerString(dataItem) {
  if ('firstName' in dataItem) {
    return dataItem.firstName + SPLITTER + dataItem.lastName + SPLITTER + dataItem.phone;
  } else {
    const street2 = dataItem.street2 ? dataItem.street2 : '';
    return dataItem.street1 + SPLITTER + street2 + SPLITTER + dataItem.city;
  }
}

interface ISuggestedFieldsProp {
  messageId: string;
  fields: IField[];
  onActionClick: (message: string, messageId: string, removeAttachmment?: boolean) => void;
}

export interface ISuggestedFieldsState {
  submitted: boolean;
}

export interface IInjectedProps extends ISuggestedFieldsProp {
  chatStore: ChatStore;
}

@inject('chatStore')
@observer
class SuggestedActions extends React.Component<ISuggestedFieldsProp, ISuggestedFieldsState> {
  protected get injected(): IInjectedProps {
    return this.props as IInjectedProps;
  }

  constructor(props: ISuggestedFieldsProp) {
    super(props);
    this.state = {
      submitted: false,
    };
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  public render() {
    const { fields } = this.props;
    const {
      chatStore: { loading },
    } = this.injected;

    const phoneRegex = new RegExp(/^(\+\d{1,2}\s?)?\(?\d{3}\)?[\s.-]?\d{3}[\s.-]?\d{4}$/);
    if (loading) {
      return null;
    }

    const Validator = (values) => {
      const returnObj = {};
      let fieldGetter;
      const fieldsList = ['firstName', 'lastName', 'phone', 'street1', 'city'];
      fields.forEach((field: IField) => {
        if (fieldsList.includes(field.entity)) {
          fieldGetter = getter(field.entity);
          if (field.entity === 'phone') {
            if (!phoneRegex.test(values.phone)) {
              returnObj[field.entity] = INVALID_PHONE_FORMAT;
            }
          }

          if (!fieldGetter(values)) {
            returnObj[field.entity] = REQUIRED_FIELD;
          }
        }
      });
      // TODO: I don't think this is possible since returnObj = {}
      // if (!returnObj) {
      //   return;
      // }
      return returnObj;
    };

    const ValidatedInput = (fieldRenderProps) => {
      const { validationMessage, visited, ...others } = fieldRenderProps;
      return (
        <div>
          <Input {...others} />
          {visited && validationMessage && <Error>{validationMessage}</Error>}
        </div>
      );
    };

    return (
      <CollectionFormStyle>
        <Form
          onSubmit={this.handleSubmit}
          validator={Validator}
          render={(formRenderProps) => (
            <FormElement
              style={{
                maxWidth: 650,
              }}
            >
              <fieldset className={'k-form-fieldset'}>
                {fields &&
                  fields.map((field: IField, index: number) => (
                    <div className='mb-3' key={field.entity}>
                      <Field
                        name={field.entity}
                        component={ValidatedInput}
                        label={field.label}
                        disabled={this.state.submitted}
                      />
                    </div>
                  ))}
              </fieldset>
              <div className='k-form-buttons'>
                <button
                  type={'submit'}
                  className='k-button'
                  disabled={!formRenderProps.allowSubmit || this.state.submitted}
                >
                  Submit
                </button>
              </div>
            </FormElement>
          )}
        />
      </CollectionFormStyle>
    );
  }

  private handleSubmit(dataItem) {
    const { chatStore } = this.injected;
    const { messageId } = this.props;

    chatStore.sendSimpleMessage(generateAnswerString(dataItem), messageId, true);
    this.setState({ submitted: true });
  }
}

export default SuggestedActions;
